// extracted by mini-css-extract-plugin
export default {"createCampaignContainer":"CreateCampaign_createCampaignContainer__T5O9j"};